import { Q } from "@constant/query-key";
import api from "@libs/api";
import { useQuery } from "@tanstack/react-query";
import { DocumentTemplate } from "types/backend/document_template";

export function useDocumentTemplatesQuery(tagId = "") {
    const query = useQuery({
        queryKey: [Q.GET_ALL_DOCUMENT_TEMPLATE, tagId],
        queryFn: async () => {
            const { data } = await api.get<DocumentTemplate[]>("/document-templates", {
                params: {
                    'tag-id': tagId
                }
            });
            return data;
        },
        staleTime: 60 * 60 * 1000,
        gcTime: 30 * 60 * 1000,
    });

    return query;
}
